module.exports = __webpack_public_path__ + "static/media/baker_bw.c63d441b.png";